<template>
  <v-container class="fill-height" fluid>
    <v-row align="center" justify="center">
      <v-col cols="12" align="center" justify="center">
        <p class="display-4">404</p>
        <p class="display-1">Page Not Found</p>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "PageNotFound",

  data: () => ({
  }),

  methods: {
  }
};
</script>

<style lang="scss" scoped>
</style>
